<template lang="pug">
	.creative--publish-schedule--item
		.flex-col.space-large
			.flex-row.space.justify
				.flex-row.space-large(:class="{ 'disabled-controls': isRunning }")
					.flex-col
						.font-small.upper.grey {{$tCaption('Name')}}
						DxTextBox(:value.sync="item.Name")
					.flex-col
						.font-small.upper.grey {{$tCaption('Start date')}}
						DxDateBox(:value.sync="item.StartDate", :width="120")
					.flex-col.space
						.font-small.upper.grey {{$tCaption('Status')}}
						span {{currentStatus.name}}
					.flex-col.space(v-if="lastExecuted")
						.font-small.upper.grey {{$tCaption('Last executed')}}
						span {{lastExecuted.format('LLL')}}
					.flex-col.space(v-if="criteriaTriggered")
						.font-small.upper.grey {{$tCaption('Criteria triggered')}}
						span {{criteriaTriggered.format('LLL')}}
				.flex-row.space
					DxButton(v-if="schedule.Logs", :text="$tCaption('Logs')", @click="$notifyMessage(schedule.Logs, { fullScreen: true })")
					DxButton(v-if="isRunning", :text="$tCaption('Refresh')", @click="refresh", :icon="isRefreshing ? 'fas fa-spinner fa-spin' : 'refresh'", :disabled="!!isRefreshing")
					DxButton(:text="isRunning ? $tCaption('Stop') : $tCaption('Run')", @click="run(!isRunning)", :icon="isProcessingRun ? 'fas fa-spinner fa-spin' : (isRunning ? 'square' : 'fas fa-play')", :disabled="!!isProcessingRun")
			.flex-col.space(:class="{ 'disabled-controls': isRunning }")
				.font-big.upper.grey {{$tCaption('Settings')}}
				.flex-row.space-large
					.flex-col.space-medium.flex-2
						.flex-row.space-large
							.flex-col.space-medium
								.flex-col
									.font-small.upper {{$tCaption('Interval')}}
									.font-small.grey {{$tCaption('How often to check Condition or re-publish creative')}}
								EditableLabelField.flex-1(:value.sync="interval", stylingMode="filled", :editingMode="true", type="time", :editorOptions="{ seconds: false, days: true }")
							.vertical-line
							.flex-col.space-medium
								.flex-col
									.font-small.upper {{$tCaption('CRON')}}
									.font-small.grey {{$tCaption('If CRON is filled then it will be used instead of Interval')}}
								EditableLabelField.flex-1(:value.sync="cron", stylingMode="filled", :editingMode="true")
						.flex-col.space-medium
							.flex-col
								.font-small.upper {{$tCaption('Condition timeout')}}
								.font-small.grey {{$tCaption('How long to check the Condition to decide should we publish (or -republish) creative or not (must be >= 24 to cover if match will be postponed)')}}
							EditableLabelField.flex-1(:value.sync="conditionTimeout", stylingMode="filled", :editingMode="true", type="time", :editorOptions="{ seconds: false, days: true }")
						.flex-col.space-medium
							.flex-col
								.font-small.upper {{$tCaption('Build timeout')}}
								.font-small.grey(v-html="$tCaption('It means how long to publish the creative after Condition was fired first time. The publication circle starts when criteria becomes true (the re-publish will happen till CriteriaTriggeredAt + Build Timeout).<br>E.g. Build Timeout could be length of match.')")
							EditableLabelField.flex-1(:value.sync="buildTimeout", stylingMode="filled", :editingMode="true", type="time", :editorOptions="{ seconds: false, days: true }")
					.flex-col.space-medium.flex-1.border-left
						.flex-col.space
							.flex-col
								.font-small.upper {{$tCaption('Criteria')}}
								.font-small.grey {{$tCaption('When Condition is true the Schedule launches the publishing every Interval')}}
							.flex-row.space
								DxButton(:text="$tCaption('Edit criteria')", @click="$refs.criteriaEditor.show(condition)", icon="fas fa-pen-to-square", :type="condition ? 'default' : 'normal'")
						.flex-col.space
							.flex-col
								.font-small.upper {{$tCaption('Run parameters')}}
								.font-small.grey {{$tCaption('Fact values of template fields which are defined in creative')}}
							.flex-row.space
								DxButton(:text="$tCaption('Edit parameters')", @click="showTemplateValuesPopup", icon="fas fa-pen-to-square", :type="templateFields.length ? 'default' : 'normal'")
		CommonServiceCriteriaEditor(ref="criteriaEditor", :templateFields="creative.JsonConfig.templateFields", :allowKeyEditing="true", @save="v => condition = v", @create-template-field="tf => $emit('create-template-field', tf)")
		Popup(v-if="templateValuesPopupVisible", :popupVisible.sync="templateValuesPopupVisible", :title="$tCaption('Run parameters')", :autosize="true", :width="420")
			.flex-col
				.grey(v-if="!templateFields.length") {{$tCaption('There is no any template field configured for this creative.')}}
				template(v-for="templateField in templateFields")
					FullStructureParameterSelector(ref="baseParam", v-bind="getBaseParamBindOptions(templateField)", @change="(paramValues, paramCaptions) => onTemplateFieldParametersChange(templateField, paramValues, paramCaptions)")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="templateValuesPopupVisible = false")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import { CREATIVE_PUBLISH_SCHEDULE_STATUSES } from 'app-core/constants';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import CommonServiceCriteriaEditor from './CommonServiceCriteriaEditor.vue';
	import Popup from 'app-core/Popup.vue'
	import FullStructureParameterSelector from 'view/webServiceCaller/FullStructureParameterSelector.vue';
	import serviceHelper from 'view/webServiceCaller/service-helper';

	export default {
		translationCategory: 'creative.PublishSchedule',
		name: 'creative--publish-schedule--item',
		components: {
			Loader, DxButton, DxTextBox, DxDateBox, DxNumberBox, EditableLabelField, CommonServiceCriteriaEditor, Popup, FullStructureParameterSelector
		},
		props: ['creative', 'schedule', 'readonly'],
		data() {
			return {
				isSaving: 0,
				item: _.cloneDeep(this.schedule),
				statuses: CREATIVE_PUBLISH_SCHEDULE_STATUSES.toLocale('name', this),
				templateValuesPopupVisible: false,
				isProcessingRun: 0,
				isRefreshing: 0
			};
		},
		computed: {
			currentStatus() {
				return this.statuses[this.schedule.Status] || this.statuses[0];
			},
			interval: {
				get: function() { return this.item?.JsonConfig?.Interval * 60; },
				set: function(v) { this.writeJsonConfig('Interval', parseInt(v / 60)); }
			},
			cron: {
				get: function() { return this.item?.JsonConfig?.Cron; },
				set: function(v) { this.writeJsonConfig('Cron', v); }
			},
			conditionTimeout: {
				get: function() { return this.item?.JsonConfig?.ConditionTimeout * 60; },
				set: function(v) { this.writeJsonConfig('ConditionTimeout', parseInt(v / 60)); }
			},
			buildTimeout: {
				get: function() { return this.item?.JsonConfig?.BuildTimeout * 60; },
				set: function(v) { this.writeJsonConfig('BuildTimeout', parseInt(v / 60)); }
			},
			externalServiceJsonCriteria: {
				get: function() { return this.item?.JsonConfig?.ExternalServiceJsonCriteria || false; },
				set: function(v) { this.writeJsonConfig('ExternalServiceJsonCriteria', v); }
			},
			templateFields: {
				get: function() { return this.item?.JsonConfig?.TemplateFields || []; },
				set: function(v) { this.writeJsonConfig('TemplateFields', v); },
				cache: false
			},
			condition: {
				get: function() { return this.item?.JsonConfig?.Condition; },
				set: function(v) { this.writeJsonConfig('Condition', v); },
				cache: false
			},
			lastExecuted() {
				const date = this.$moment(this.item?.LastExecuted);
				return date > (new Date(1901, 1, 1)) ? date : null;
			},
			criteriaTriggered() {
				const date = this.$moment(this.item?.CriteriaTriggered);
				return date > (new Date(1901, 1, 1)) ? date : null;
			},
			isRunning() {
				return [1, 2].indexOf(this.schedule?.Status) > -1;
			}
		},
		watch: {
			item: {
				handler() {
					if (this.$currentScheduleId === this.schedule?.Oid) {
						this.$save();
					}
				},
				deep: true
			},
			schedule() {
				if (this.$currentScheduleId === this.schedule?.Oid) return;
				this.$currentScheduleId = this.schedule?.Oid;
				this.item = _.cloneDeep(this.schedule);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativePublishScheduleItem = this;
			
			this.$save = _.debounce(this.save, 1000, {
				leading: false,
				trailing: true
			});
			
			this.$currentScheduleId = this.schedule?.Oid;
		},
		destroyed() {
			delete this.$currentScheduleId;
			delete this.$savePromise;
		},
		methods: {
			refresh() {
				this.isRefreshing++;
				this.$Data.getExternalApi('PublicationSchedule/Get', `id=${this.schedule.Oid}`).then(r => {
					if (r?.Oid) {
						_.assign(this.schedule, r);
						_.assign(this.item, r);
					}
				}).finally(() => this.isRefreshing--);
			},
			async run(activate) {
				this.isProcessingRun++;
				if (activate) {
					await this.save();
				}
				return this.$Data.postExternalApi(activate ? 'PublicationSchedule/Start' : 'PublicationSchedule/Stop', {
					Id: this.schedule.Oid 
				}).then(r => {
					if (r?.Data) {
						_.assign(this.schedule, r?.Data);
						_.assign(this.item, r?.Data);
					}
				}).finally(() => this.isProcessingRun--);
			},
			writeJsonConfig(prop, val) {
				if (!this.item.JsonConfig) {
					this.$set(this.item, 'JsonConfig', {});
				}
				this.$set(this.item.JsonConfig, prop, val);
			},
			save() {
				_.assign(this.schedule, this.item);
				this.isSaving++;
				if (this.isSaving > 1) return this.$savePromise;
				this.$set(this.schedule, '__saving', true);
				this.$savePromise = this.$Data.postExternalApi('PublicationSchedule/CreateUpdate', { ...this.schedule, Creative: { Oid: this.creative.Oid } }).finally(() => {
					if (this.isSaving > 1) {
						this.isSaving = 0;
						this.save();
					} else {
						this.isSaving--;
						this.$set(this.schedule, '__saving', false);
					}
				});
				return this.$savePromise;
			},
			showTemplateValuesPopup() {
				this.templateValuesPopupVisible = false;
				if (!this.item?.JsonConfig?.TemplateFields) {
					this.$set(this.item.JsonConfig, 'TemplateFields', []);
				}
				if (this.templateFields.some(f => !this.creative.JsonConfig.templateFields?.find(t => t.id === f.id))) {
					this.templateFields = this.templateFields.filter(f => this.creative.JsonConfig.templateFields?.find(t => t.id === f.id));
				}
				this.creative.JsonConfig.templateFields.map(f => {
					if (!this.templateFields.find(f => this.creative.JsonConfig.templateFields?.find(t => t.id === f.id))) {
						this.templateFields.push(_.cloneDeep(f));
					}
				});
				setImmediate(() => {
					this.templateValuesPopupVisible = true;
				});
			},
			onTemplateFieldParametersChange(templateField, paramValues, paramCaptions) {
				if (__DEBUG__)
					console.debug('onTemplateFieldParametersChange', { templateField, paramValues, paramCaptions });

				if (!templateField.services) {
					templateField.services = [];
				}

				templateField.services = Object.keys(paramValues).map(paramName => {
					const res = {
						Name: paramName,
						Value: paramValues[paramName]
					}
					if (paramCaptions && paramCaptions[paramName]) {
						res.Caption = paramCaptions[paramName];
					}
					return res;
				});

				this.$set(templateField, 'default', paramCaptions && paramCaptions[templateField.id] || paramValues[templateField.id]);
			},
			getBaseParamBindOptions(templateField) {
				return {
					paramResolver: () => serviceHelper.getParamFromTemplateField(templateField, this),
					parameter: null,
					...this.getParamValuesFromTemplateField(templateField)
				}
			},
			getParamValuesFromTemplateField(templateField) {
				return (templateField.services || []).reduce((res, f) => {
					res.paramValues[f.Name] = f.Value;
					if (f.Caption)
						res.paramCaptions[f.Name] = f.Caption;
					return res;
				}, { paramValues: {}, paramCaptions: {} });
			},
		}
	};
</script>
<style lang='scss'>
	.creative--publish-schedule--item {
		.border-left {
			border-left: 1px solid #efefef;
			padding-left: 20px;
		}
	}
</style>
